const translations = {
    roles: 'Roles',
    rolesAreRequired: 'At least one role is required'
};

export default translations;
